"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.aboutUs = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var classnames_1 = require("classnames");
var Pages_1 = require("@/rendering/common/Pages");
var AboutusAction_1 = require("@/pages/aboutUs/actions/AboutusAction");
var AboutPage_1 = require("@/pages/common/components/AboutPage");
var mapStateToProps = function (state) { return (__assign(__assign({}, state.aboutUs), { menu: state.layout.menulist.filter(function (it) { return it.page === Pages_1.Pages.ABOUT; })[0] })); };
var mapDispatchToProps = function (dispatch) { return ({
    onPlayClicked: function () { return dispatch(AboutusAction_1.default.onPlayClicked()); },
}); };
exports.aboutUs = function (props) {
    var youtubeImg = "https://img.youtube.com/vi/" + props.youtubeId + "/mqdefault.jpg";
    var youtubeSrc = "https://www.youtube.com/embed/" + props.youtubeId + (props.isPlaying ? '?autoplay=1' : '');
    var youtubeDivStyle = { backgroundImage: "url(" + youtubeImg + ")" };
    var bigHeadStyle = {
        backgroundImage: 'url(/res/img/aboutbg.jpg)',
        backgroundPosition: 'center',
    };
    var bigHeadClasses = classnames_1.default([
        'c-bighead',
        'c-bighead--hero',
        {
            'c-bighead--loaded': props.isLoaded,
        },
    ]);
    var videoClasses = classnames_1.default([
        'c-bighead__video',
        {
            'c-bighead__video--active': props.isPlaying,
        },
    ]);
    var allowAttr = {
        allow: 'autoplay',
        allowFullScreen: true,
        frameBorder: '0',
    };
    var customHead = (React.createElement("div", { className: "c-bighead__bgwrap" },
        React.createElement("div", { className: bigHeadClasses, style: bigHeadStyle },
            React.createElement("div", { className: "c-bighead__block" },
                React.createElement("h1", { className: "c-bighead__blockcaption" }, props.headerCaption),
                React.createElement("a", { onClick: props.onPlayClicked, className: "c-bighead__blockaction" },
                    React.createElement("div", { className: "c-bighead__blockaction-img" },
                        React.createElement("div", { className: "c-bighead__blockaction-play" },
                            React.createElement("span", { className: "fas fa-play-circle " }))),
                    React.createElement("div", { className: "c-bighead__blockaction-text" }, props.knowMore))),
            React.createElement("div", { className: videoClasses }, props.isPlaying ? (React.createElement("iframe", __assign({ src: youtubeSrc }, allowAttr))) : null))));
    var renderParagraphs = function (paras) {
        return paras.map(function (it, i) { return (React.createElement("p", { key: i }, it.text)); });
    };
    var renderDetail = function (detail, j) {
        return (React.createElement("div", { key: j, className: "c-quotebox__listitem" },
            React.createElement("div", { className: "c-quotebox__label" },
                j + 1,
                ". "),
            React.createElement("div", { className: "c-quotebox__value" },
                React.createElement("div", { className: "c-quotebox__caption" }, detail.text),
                React.createElement("div", { className: "c-quotebox__sample" }, detail.example))));
    };
    var renderMeanings = function (meanings) {
        return meanings.map(function (meaning, i) {
            return (React.createElement("div", { key: i, className: "c-quotebox__meaning" },
                React.createElement("div", { className: "c-quotebox__title" }, meaning.type),
                React.createElement("div", { className: "c-quotebox__list" }, meaning.detail.map(function (it, j) { return renderDetail(it, j); }))));
        });
    };
    var renderQuoteBox = function (it) {
        return (React.createElement("div", { className: "c-quotebox c-article__float" },
            React.createElement("div", { className: "c-quotebox__quote" },
                React.createElement("div", { className: "o-openquote" },
                    React.createElement("img", { src: "/res/img/quote.png", alt: "" }))),
            React.createElement("div", { className: "c-quotebox__main" },
                React.createElement("div", { className: "c-quotebox__bold" }, it.word),
                React.createElement("div", { className: "c-quotebox__light" }, it.pronounce)),
            React.createElement("div", { className: "c-quotebox__side" }, renderMeanings(it.meanings))));
    };
    var renderLink = function (link, i) {
        var imageStyle = { backgroundImage: "url(" + link.image + ")" };
        return (React.createElement("div", { key: i, className: "l-gridlist__item" },
            React.createElement("a", { href: link.link, className: "c-card c-card--auto" },
                React.createElement("div", { className: "c-card__image" },
                    React.createElement("div", { className: "c-card__image-body", style: imageStyle })),
                React.createElement("div", { className: "c-card__info c-card__info--auto u-text-center" },
                    React.createElement("div", { className: "c-card__head" },
                        React.createElement("h3", { className: "c-card__title" }, link.text))))));
    };
    return (React.createElement(AboutPage_1.default, { customHead: customHead, currentPage: Pages_1.Pages.ABOUTUS, menu: props.menu },
        React.createElement("div", { className: "c-article" },
            React.createElement("h2", { className: "c-article__title" }, props.pageTitle),
            renderQuoteBox(props.definition),
            React.createElement("div", { dangerouslySetInnerHTML: { __html: props.html } })),
        React.createElement("div", { className: "c-ssection c-ssection--short" },
            React.createElement("div", { className: "l-gridlist l-gridlist--nopad l-gridlist--grid l-gridlist--rev" },
                React.createElement("div", { className: "l-gridlist__body " }, props.links.map(function (it, i) { return renderLink(it, i); }))))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.aboutUs);
